import { Modal, PasswordInput, Button, Stack, Text, Group } from '@mantine/core'
import { useForm, Controller } from 'react-hook-form'
import toast from 'react-hot-toast'
import { api } from '@/lib/api'

interface ChangePasswordModalProps {
  opened: boolean
  onClose: () => void
}

interface ChangePasswordValues {
  currentPassword: string
  newPassword: string
  confirmPassword: string
}

const defaults: ChangePasswordValues = {
  currentPassword: '',
  newPassword: '',
  confirmPassword: '',
}

export default function ChangePasswordModal({ opened, onClose }: ChangePasswordModalProps) {
  const {
    control,
    handleSubmit,
    reset,
    getValues,
    formState: { errors, isSubmitting },
  } = useForm<ChangePasswordValues>({ defaultValues: defaults })

  const onSubmit = handleSubmit(async (values) => {
    try {
      await api.admin.changePassword({
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
      })
      toast.success('Нууц үг амжилттай солигдлоо')
      reset(defaults)
      onClose()
    } catch (err: unknown) {
      toast.error(err instanceof Error ? err.message : 'Нууц үг солиход алдаа гарлаа')
    }
  })

  const handleClose = () => {
    reset(defaults)
    onClose()
  }

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title="Нууц үг солих"
      centered
      size="sm"
    >
      <form onSubmit={onSubmit}>
        <Stack>
          <Controller
            name="currentPassword"
            control={control}
            rules={{ required: 'Одоогийн нууц үгийг оруулна уу' }}
            render={({ field }) => (
              <PasswordInput
                label="Одоогийн нууц үг"
                placeholder="Одоогийн нууц үгээ оруулна уу"
                {...field}
                error={errors.currentPassword?.message}
              />
            )}
          />
          <Controller
            name="newPassword"
            control={control}
            rules={{
              required: 'Шинэ нууц үг хамгийн багадаа 8 тэмдэгт байх ёстой',
              minLength: { value: 8, message: 'Шинэ нууц үг хамгийн багадаа 8 тэмдэгт байх ёстой' },
            }}
            render={({ field }) => (
              <PasswordInput
                label="Шинэ нууц үг"
                placeholder="Хамгийн багадаа 8 тэмдэгт"
                {...field}
                error={errors.newPassword?.message}
              />
            )}
          />
          <Controller
            name="confirmPassword"
            control={control}
            rules={{
              validate: (v) => (v === getValues('newPassword') ? true : 'Нууц үг таарахгүй байна'),
            }}
            render={({ field }) => (
              <PasswordInput
                label="Шинэ нууц үг давтах"
                placeholder="Шинэ нууц үгээ дахин оруулна уу"
                {...field}
                error={errors.confirmPassword?.message}
              />
            )}
          />
          <Text size="xs" c="dimmed">
            Нууц үг солисны дараа дахин нэвтрэх шаардлагагүй.
          </Text>
          <Group justify="flex-end">
            <Button variant="default" onClick={handleClose} disabled={isSubmitting}>
              Болих
            </Button>
            <Button type="submit" loading={isSubmitting} disabled={isSubmitting}>
              Солих
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  )
}
